<template>
  <div style="height:100%">
    <portal to="app-header">
      <span>{{ $t('maintenancePlan.title') }}</span>
      <v-btn icon small class="ml-4 mb-1">
        <v-icon
          v-text="'$info'"
        ></v-icon>
      </v-btn>
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            v-on="on"
            v-bind="attrs"
            class="ml-2 mb-1"
            @click="refreshMaintenancePlans"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        {{ $t('maintenancePlan.lastRefreshed') }} <strong>{{ lastRefreshedAt }}</strong>
      </v-tooltip>
    </portal>
    <planning-toolbar />
    <planning-drawer />
    <v-progress-linear
      :indeterminate="true"
      v-if="loading"
    ></v-progress-linear>
    <planning-list />
  </div>
</template>

<script>
import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
import PlanningToolbar from '../components/PlanningToolbar.vue';
import PlanningDrawer from '../components/PlanningDrawer.vue';
import PlanningList from '../components/PlanningList.vue';

export default {
  name: 'MaintenancePlanning',
  components: {
    PlanningToolbar,
    PlanningDrawer,
    PlanningList,
  },
  computed: {
    ...mapState('maintenancePlanning', ['loading', 'lastRefreshedAt']),
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  created() {
    this.setExtendedHeader(true);
  },
  methods: {
    ...mapMutations('helper', ['setExtendedHeader']),
    ...mapActions('maintenancePlanning', ['fetchPlanningList']),
    refreshMaintenancePlans() {
      this.fetchPlanningList();
    },
    gotToSettings() {
      this.$router.push({ name: 'maintenancePlanSettings' });
    },
  },
};
</script>
